import(/* webpackMode: "eager" */ "E:\\PROJECT\\grasitech\\src\\app\\(site)\\layout.tsx");
